import { render } from "./PanelsDemo.vue?vue&type=template&id=03a13980&scoped=true"
import script from "./PanelsDemo.vue?vue&type=script&lang=js"
export * from "./PanelsDemo.vue?vue&type=script&lang=js"

import "./PanelsDemo.vue?vue&type=style&index=0&id=03a13980&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a13980"]])

export default __exports__